import { useState } from "react";

import "./faq.css"; // import the CSS file
import Maincard from "../../comman/maincard";
import SEO from "../../comman/SEO";

const FaqPage = () => {
  const faqs = [
    {
      question: "Where is Vaikunta Maha Ruchulu located in Visakhapatnam?",
      answer: [
        "We are located at D No: 50-121-60/1A, 4th Town Police Station Road, Balayya Sastry Layout, Seethammadhara, Visakhapatnam. We are easily accessible for anyone looking for the best pure veg restaurant in the Seethammadhara area."
      ],
    },
    {
      question: "What are your restaurant's opening and closing timings?",
      answer: [
        "We are open every day from 7:00 AM to 10:30 PM. We serve morning tiffins, lunch, and dinner, remaining open on weekends and major public holidays."
      ],
    },
    {
      question: "Is there parking available near the restaurant?",
      answer: [
        "Yes, we offer convenient parking for our dining guests. Finding parking in Seethammadhara can be busy, so our facilities ensure a hassle-free visit for you and your family."
      ],
    },
    {
      question: "What payment methods do you accept?",
      answer: [
        "We accept all major payment methods, including UPI (Google Pay, PhonePe, Paytm), Credit Cards, Debit Cards, and Cash."
      ],
    },
    {
      question: "Is Vaikunta Maha Ruchulu a strictly 100% pure vegetarian restaurant?",
      answer: [
        "Yes, absolutely. We operate a strictly 100% pure vegetarian kitchen with no cross-contamination. We serve authentic South Indian and North Indian vegetarian cuisine."
      ],
    },
    {
      question: "Do you serve Jain food or dishes without onion and garlic?",
      answer: [
        "Yes, we offer a dedicated selection of no onion, no garlic food in Vizag. Please inform our staff of your dietary requirements, and we will prepare a delicious meal customized to your needs."
      ],
    },
    {
      question: "What are the signature dishes or best-sellers on your menu?",
      answer: [
        "Our most popular items include our authentic South Indian Veg Thali, Gongura Mushroom Pulao, Topi Dosa, and our famous Pesarattu Upma."
      ],
    },
    {
      question: "What are the timings for your Unlimited Vegetarian Breakfast?",
      answer: [
        "Our popular unlimited veg breakfast is served daily from 7:30 AM to 11:00 AM. It includes a wide variety of freshly made traditional South Indian tiffins."
      ],
    },
    {
      question: "Do you offer home delivery and takeaway in Vizag?",
      answer: [
        "Yes, we offer both. You can visit the restaurant for secure, spill-proof takeaway, or you can order pure veg food delivery straight to your home via Swiggy and Zomato."
      ],
    },
    {
      question: "Do I need to make a reservation or book a table in advance?",
      answer: [
        "Walk-ins are always welcome! However, if you are planning to dine with a large family or group, especially on weekends or during festivals, we recommend calling us ahead of time to reserve a table."
      ],
    },
    {
      question: "Do you provide pure veg catering services or take bulk food orders?",
      answer: [
        "Yes, we specialize in premium pure veg catering in Visakhapatnam. We handle bulk orders and catering for weddings, birthdays, pujas, and corporate events. Contact us directly for special event menus and pricing."
      ],
    },
    {
      question: "Is the restaurant family-friendly and suitable for large groups?",
      answer: [
        "Yes, Vaikunta Maha Ruchulu is designed for family dining. We offer spacious seating, a comfortable air-conditioned ambiance, and group dining options perfect for celebrating special occasions together."
      ],
    },
  ];


  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <>
      <SEO
        title="FAQ | Vaikunta Maha Ruchulu - Pure Veg Restaurant in Vizag"
        description="Have questions about Vaikunta Maha Ruchulu? Read our FAQ to learn about our pure veg Andhra menu, catering services, timings, and location in Vizag."
        keywords="
           Vaikunta Maha Ruchulu FAQ,
Pure veg restaurant Vizag info,
Andhra veg restaurant timings,
Visakhapatnam vegetarian food menu,
Vaikunta Maha Ruchulu location,
Information about premium pure veg dining in Vizag,
Details on authentic South Indian thali offerings,
Common questions about 100% hygienic vegetarian food preparation,
Dietary restrictions and pure veg catering options,
What are the timings for Vaikunta Maha Ruchulu in Vizag?,
Does Vaikunta Maha Ruchulu serve 100% pure veg food?,
Where is Vaikunta Maha Ruchulu located in Visakhapatnam?,
Does Vaikunta Maha Ruchulu offer pure veg catering for events?,
Are Jain or no-onion, no-garlic options available?,
        "
        url="https://vaikuntamaharuchulu.com/"

      />
      <div>
        <Maincard
          image={"assets/faq.jpg"}
          title={"Frequently Asked Questions"}
        />
      </div>

      <div className="faq-container">
        <h1 className="faq-title">FAQ</h1>
        <div className="faq-list">
          {faqs.map((faq, index) => (
            <div key={index} className="faq-item">
              <button
                className="faq-question"
                onClick={() => toggleFAQ(index)}
              >
                <span>{faq.question}</span>
                <span className="faq-icon">{openIndex === index ? "−" : "+"}</span>
              </button>
              {openIndex === index && (
                <div className="faq-answer">
                  {faq.answer.map((item, idx) => (
                    <p key={idx}>{item}</p>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default FaqPage;
